import { render } from "./ShortForm.vue?vue&type=template&id=53b4223a&scoped=true"
import script from "./ShortForm.vue?vue&type=script&lang=js"
export * from "./ShortForm.vue?vue&type=script&lang=js"

import "./ShortForm.vue?vue&type=style&index=0&id=53b4223a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b4223a"]])

export default __exports__